import { ReactNode, useMemo } from "react";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import styles from "./TopFragmentWrapper.module.css";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

type TopFragmentWrapperProps = {
  children: ReactNode;
  state: TaskState | Loading;
};

const TopFragmentWrapper = ({ children, state }: TopFragmentWrapperProps) => {
  const stateClassName = useMemo(() => {
    if (isLoading(state)) {
      return styles["pending"];
    }

    switch (state) {
      case "pending":
        return styles["pending"];
      case "completed":
        return styles["completed"];
      case "closed":
        return styles["closed"];
    }
  }, [state]);

  return (
    <div className={`${styles["root"]} ${stateClassName}`}>{children}</div>
  );
};

export default TopFragmentWrapper;
